import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';


// Import the functions you need from the SDKs you need
// import { initializeApp } from "firebase/app";
// import { getAuth } from "firebase/auth";
// import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBcAhVSbEDYJ4q9kd7G9ajMVfwfvqlyhSQ",
  authDomain: "clone-84272.firebaseapp.com",
  projectId: "clone-84272",
  storageBucket: "clone-84272.appspot.com",
  messagingSenderId: "232990321914",
  appId: "1:232990321914:web:33cde99c5ffe0588112d43",
  measurementId: "G-6YNZMXMRGJ",
};

// Initialize Firebase
const app = firebase.initializeApp(firebaseConfig);
const auth = firebase.auth();
const db = app.firestore();
// const analytics = getAnalytics(app);

export { auth, db };